function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 17"
}, props), React.createElement("path", {
  d: "M3.01 0A3.004 3.004 0 000 3.01V13.15a3.004 3.004 0 003.01 3.01H13.15a3.004 3.004 0 003.01-3.01V3.011A3.004 3.004 0 0013.15 0H3.011zm19.746 1.495l-2.327.64c-1.011.278-2.214.988-2.216 2.215v7.458c0 1.227 1.031 1.889 2.216 2.215l2.327.642V1.495z",
  fill: "#26BED2"
})));